exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-wrap[data-v-45db2d38] {\n  text-align: center;\n}", ""]);

// exports
